import { createSearchQuery } from '@/logic/main/utils';

// removes all the whitespace from query, allows for easier debugging in
// devtools network panel, and slightly reduces transfer
export function parseQuery(query: string): string {
  return query.replace(/(?:\n(?:\s*))+/g, ' ');
}

export async function fetchGraphQL<ResponseType>(
  url: string,
  query: string,
  headers: { [header: string]: string } = {}
): Promise<ResponseType> {
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
    body: JSON.stringify({ query: parseQuery(query) }),
  }).then(res => (res.ok ? res.json() : Promise.reject(res)));
}

export async function postData<ResponseType>({
  url,
  body,
  queryParameters = {},
  headers = {},
}: {
  url: string;
  body: { [key: string]: any };
  queryParameters?: { [key: string]: string | boolean | undefined };
  headers?: { [header: string]: string };
}): Promise<ResponseType> {
  const queryString = createSearchQuery(queryParameters);
  return fetch(`${url}${queryString}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
    mode: 'cors',
    credentials: 'include',
    body: JSON.stringify(body),
  })
    .then(res => {
      return res.json();
    })
    .catch(e => {
      console.error(e);
      return {};
    });
}

export async function fetchData<ResponseType>({
  url,
  headers,
  queryParameters,
}: {
  url: string;
  headers?: { [header: string]: string };
  queryParameters?: {
    [key: string]: string | boolean | string[] | number | undefined;
  };
}): Promise<ResponseType> {
  const queryString = createSearchQuery(queryParameters);

  return fetch(`${url}${queryString}`, {
    mode: 'cors',
    credentials: 'include',
    ...(headers ? { headers } : null),
  }).then(res => (res.ok ? res.json() : Promise.reject(res)));
}
